var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"base-search-term"},[_vm._v(" "+_vm._s(_vm.preSearch)),(_vm.search)?_c('strong',[_vm._v(_vm._s(_vm.search))]):_vm._e(),_vm._v(_vm._s(_vm.postSearch)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }